import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { CORNER_POSITION_OPTIONS } from '../../../../Preview/PreviewDisplayConstants';
import SelectListItem from '../../../../../../list-items/SelectListItem/SelectListItem';

const YouTubeCtaPositionListItem = (props) => {
    const { youTubeCtaCornerPosition, updateElementsSettings } = props;
    
    const onPositionChange = (event) => {
        updateElementsSettings({ 
            youTubeCta: {
                enabled: true, 
                cornerPosition: event.target.value
            }
        });
    };
    
    return (
        <SelectListItem
            text='Position'
            value={youTubeCtaCornerPosition}
            onChange={onPositionChange}
            options={CORNER_POSITION_OPTIONS}
        />
    );
};

const mapStateToProps = (state) => {
    const { cornerPosition: youTubeCtaCornerPosition } = state.createPreview.present.videoSettings.elements.youTubeCta;
    return { youTubeCtaCornerPosition };
}

const mapDispatchToProps = (dispatch) => {
    const updateElementsSettings = (properties) => dispatch(createActions.updateElementsSettings(properties));
    return { updateElementsSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(YouTubeCtaPositionListItem);